import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ProposalRepository } from '../infra/ProposalRepository'

export type SubmitAwardConfirmationFactoryDependencies = {
  repository: ProposalRepository
}

export function submitAwardConfirmationFactory({
  repository,
}: SubmitAwardConfirmationFactoryDependencies) {
  return async function submitAwardConfirmationImpl(rfpId: string) {
    return repository.submitAwardConfirmation(rfpId)
  }
}

export function submitAwardConfirmation(rfpId: string) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ProposalRepository({ httpClient })
  const submitAward = submitAwardConfirmationFactory({ repository })
  return submitAward(rfpId)
}
